<div class="drop-container flex-column d-flex justify-content-center text-center mb-4" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
    <div class="mt-3 mb-2">
        <img src="./assets/images/upload.png" *ngIf="!showImg"/>
    </div>
    <small class="text-secondary" *ngIf="!bankStmt">Upload {{fatca ? 'TIN Copy' : additionalImageName ? additionalImageName :additionalImageName1 ? "Additional Tax" : imageName}}  {{additionalImageName1? 'Image 2': fileType === 'img'? 'Image': '' }}</small>
    <small class="text-secondary" *ngIf="bankStmt">Upload {{statement}}</small>
   

    <div class="col-12 scroll-drag" *ngIf="showImg" (click)="imgModal()">
        <!--Featured image-->
        <div class="overlay hm-white-slight waves-light uploaded-image m-auto card" [ngClass]="(fileType === 'pdf' || pdffile) ? 'border-0 py-2': ''">
          <img [src]="image" class="mw-100 mh-100" *ngIf="fileType === 'img' || (fileType === 'both' && !pdffile)">
          <img src="./assets/images/pdf-icon.png" style="height: auto; width: 60px; margin: auto" *ngIf="fileType === 'pdf' || pdffile">
          <a>
            <div class="mask"></div>
          </a>
        </div>
    </div>

    <label class="upload-button mt-2 mb-2 small" [ngStyle]="{
  'pointer-events': (imageName === 'Permanent Address Front') && digilockerupload === 'Y' ? 'none' : 'auto',
  'opacity': (imageName === 'Permanent Address Front') && digilockerupload === 'Y' ? 0.5 : 1}">
        Click to browse or drop here to upload
        <input *ngIf="fileType === 'img'" id="{{imageName}}" type="file" accept="image/*" ngFileSelect [options]="options" [disabled]="!disableFileUpload && imgName === 'PAN'" (uploadOutput)="onUploadOutput($event)" (change)="onFileChange($event)" [uploadInput]="uploadInput">
        <input *ngIf="fileType === 'pdf'" id="{{imageName}}" type="file" accept="application/pdf,.pdf" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
        <input *ngIf="fileType === 'both'" id="{{imageName}}" type="file" accept="application/pdf,.pdf,image/*" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" (change)="onFileChange($event)">
    </label>

    
    <p>
        <small class="text-secondary f-11" *ngIf="fileType === 'img'">Formats: png/jpeg/jpg | Max Size: 4mb</small>
        <small class="text-secondary f-11" *ngIf="fileType === 'pdf'">Format: pdf | Max Pages: {{imageName === 'CDC Booklet' ? '5': imageName === 'Offer Letter' ? '20': '100'}}</small>
        <small class="text-secondary f-11" *ngIf="fileType === 'both'">Format: png/jpeg/jpg/pdf | Max Size: 4mb {{imageName === '| Max Pages: Foreign Address Front' || imageName === ' | Max Pages:Foreign Address Back' ? 5 : fatca ? '| Max Pages: 5' :  ''}}</small>
    </p>
</div>

<div class="modal fade" id="myModal{{imageName}}" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content" *ngIf="showImg">
            <div class="modal-header border-0">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
            <div class="modal-body p-4">
              <img [src]="image" class="mw-100 mh-100" *ngIf="fileType === 'img' ||  (fileType === 'both' && !pdffile)">
              <!-- <embed [src]="pdffile" style="width: 100%;" height="300" *ngIf="fileType === 'pdf' || pdffile"> -->
                <pdf-viewer [src]="pdffile.changingThisBreaksApplicationSecurity" 
              style="width: 100%; height: 300px" *ngIf="fileType === 'pdf' || pdffile"></pdf-viewer>
            </div>            
        </div>
    </div>
</div>

<div class="modal fade" id="imagecropper{{imageName}}" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
          <div class="modal-body p-3">
            <div class="row mx-0">
              <div class="col-md-6">
                <p>
                  Crop your Image Here.
                </p>
                <image-cropper #imageCropper [imageChangedEvent]="imgChangeEvt" [format]="getExtension" (imageCropped)="cropImg($event)" (imageLoaded)="imgLoad()" [maintainAspectRatio]="false"
                (cropperReady)="initCropper()" [output]="'base64'" (loadImageFailed)="imgFailed()">
              </image-cropper>
              </div>
              <div class="col-md-6" *ngIf="image">
                <h6>Image Preview</h6>
                <img [src]="image" class="gImage img-fluid" />
              </div>
            </div>
          </div>      
          <div class="modal-footer">
            <button type="button" class="btn btn-primary px-3" data-bs-dismiss="modal" (click)="croppedImageupload()">Upload</button>
          </div>      
      </div>
  </div>
</div>


<ngx-ui-loader [loaderId]="imgName"></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>